import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";

// Garantia: caso algum script externo tente acessar `process` em runtime, evita erro em dev
if (typeof window !== "undefined" && typeof window.process === "undefined") {
  window.process = { env: {} };
}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

// Registra service worker apenas em produção; em desenvolvimento pode causar erro de MIME/HTML
if (process.env.NODE_ENV === 'production') {
  serviceworker.register()
} else {
  serviceworker.unregister()
}
